export default "__VITE_ASSET__B__I$8xq__"